(() => {
  const mobile = window.matchMedia('(max-width: 767px)');
  let bubble;
  let original;
  let frame;
  let wasMobile = false;
  let bubbleObserver;
  const apply = () => {
    frame = null;
    if (!bubble?.isConnected) {
      bubble = document.querySelector('.woot-widget-bubble');
      original = null;
      bubbleObserver?.disconnect();
      if (bubble) {
        discovery.disconnect();
        bubbleObserver = new MutationObserver(schedule);
        bubbleObserver.observe(bubble, { attributes: true, attributeFilter: ['style'] });
      }
    }
    if (!bubble) return;
    if (!original) original = ['bottom', 'width', 'right'].map(name => [name, bubble.style.getPropertyValue(name), bubble.style.getPropertyPriority(name)]);
    if (mobile.matches) {
      wasMobile = true;
      for (const [name, value] of [['bottom', 'calc(12px + env(safe-area-inset-bottom, 0px))'], ['width', '48px'], ['right', '12px']]) {
        if (bubble.style.getPropertyValue(name) !== value) bubble.style.setProperty(name, value, 'important');
      }
      bubble.setAttribute('aria-label', bubble.title || 'Chat');
    } else if (wasMobile) {
      wasMobile = false;
      for (const [name, value, priority] of original) {
        if (bubble.style.getPropertyValue(name) !== value) bubble.style.setProperty(name, value, priority);
      }
    }
  };
  const schedule = () => { if (!frame) frame = window.requestAnimationFrame(apply); };
  const discovery = new MutationObserver(schedule);
  discovery.observe(document.body, { childList: true, subtree: true });
  mobile.addEventListener('change', schedule);
  window.addEventListener('chatwoot:ready', schedule);
  schedule();
})();
